import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  HelpBlock as Message,
  Button as SearchButton
} from 'react-bootstrap';
import classnames from 'classnames';

import styles from './SearchBar.css';
import {
  Search as SearchIcon,
  Times as TimesIcon,
} from '../icons/Icons.jsx';

class SearchBarLayout extends React.Component {
  focusTextInput = () => {
    this.input.focus();
  }

  render() {
    let {
      message,
      value,
      onChange,
      onClear,
      placeholder,
      submitTerm,
      ...rest
    } = this.props;
    const searchBar = classnames('hx-search-bar');
    const searchMessage = classnames('hx-search-message');

    return (
      <div
        className={styles.container}>
        <FormControl
          className={searchBar}
          inputRef={ref => { this.input = ref; }}
          placeholder={placeholder}
          type="text"
          value={value}
          onChange={onChange}
          {...rest}
        />
        {
          value !== ''
            ? <TimesIcon className="hx-search-clear-icon" onClick={onClear} />
            : null
        }
        <SearchButton
          className="hx-search-button"
          onClick={() => {
            submitTerm();
            this.focusTextInput();
          }}
        >
          <SearchIcon className="hx-search-icon" />
        </SearchButton>
        {
          message
            ? <Message className={searchMessage}>{message}</Message>
            : null
        }
      </div>
    );
  }
}

SearchBarLayout.propTypes = {
  message: PropTypes.node, 
  value: PropTypes.string, 
  onChange: PropTypes.func,
  onClear: PropTypes.func, 
  placeholder: PropTypes.string, 
  submitTerm: PropTypes.func
};

export default SearchBarLayout;
